import Controller from 'controllers/controller';
import ModalController from 'controllers/components/modal';
import Elements from 'tools/elements';
import Bus from 'tools/bus';
import Animator from 'tools/animator';

class ModalsController extends Controller {
    ready() {
        this.idPrefix = 'pd-modal-';
        
        this.elements = new Elements;
        
        this.animator = new Animator({
            elements: this.elements.all()
        });
        
        this.bus = new Bus(this);
        
        this.modalControllersById = { };
        
        this.cacheElements();
        this.attachEvents();
    }
    
    cacheElements() {
        this.elements.queryOne('backdrop', '#pd-modal-backdrop');
        this.elements.queryAll('modals', '.pd-modal');
        this.elements.queryAll('triggers', '.pd-modal-trigger');
    }
    
    attachEvents() {
        this.on('open-modal', this.onOpenModal);
        this.app.on('controllers-initialised', this.onAppControllersInitialised);
        this.elements.each('triggers', trigger => {
            trigger.addEventListener('click', this.onTriggerClick);
        })
    }

    onTriggerClick(event) {
        event.preventDefault();
        let id = event.currentTarget.getAttribute('data-modal-id');

        this.openModal(id);
    }
    
    buildModalId(id) {
        let modalId = id;
        if( id.search(this.idPrefix) !== 0 ) { // Check to see if the prefix hasn't already been added
            modalId = this.idPrefix + id;
        }
        return modalId;
    }

    /**
     * Get a modal instance by ID
     * 
     * @param id
     * 
     * @return {ModalController|null}
     */
    getModal(id) {
        let modal = this.modalControllersById[
            this.buildModalId(id)
        ];
        
        return modal || null;
    }

    onAppControllersInitialised() {
        // Only init when controllers are initialised so that ModalController instances may access this instance of
        // ModalsController via this.app.modalsController. Otherwise, when the ModalController's are instantiated, the
        // property 'modalsController' will not exist on the AppController instance yet.
        this.initModalControllers();
    }

    /**
     * Open a modal by the given ID.
     * 
     * @param id
     */
    openModal(id) {
        // Use the events system to open the modal to ensure an event is always emitted, so that other code can know
        // when a modal has been openned.
        this.emit('open-modal', id);
    }

    onOpenModal(id) {
        if ( ! this.modalControllersById[id]) {
            throw new Error(`Invalid modal id passed: '${id}'`);
        }
        
        this.getModal(id).open();
    }

    initModalControllers() {
        this.elements.each('modals', modal => this.initModalController(modal));
    }
    
    initModalController(modal) {
        let id = modal.getAttribute('id');
        
        this.modalControllersById[id] = this.app.make(ModalController, modal);
    }
    
    showBackdrop() {
        this.animator.fromTo('backdrop', {
            display: 'block',
            opacity: 0
        }, {
            opacity: 1
        })
    }
    
    hideBackdrop() {
        this.animator.to('backdrop', {
            opacity: 0,
            onComplete: () => {
                this.animator.set('backdrop', {
                    display: 'none'
                })
            }
        })
    }
}

export default ModalsController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/modals.js